<template>
<div class="container-fluid">
    <div class="row">
        <div>
            <h4 class="admin_txt">State Admin</h4>
        </div>
        <div class="card_box">
            <vue-bootstrap4-table v-if="rows.length" :rows="rows" :columns="columns" :config="config">
                <template slot="empty-results">
                    No State Admin Found
                </template>
                <template slot="id" slot-scope="props">
                    <span>
                        {{props.row.vbt_id}}
                    </span>
                </template>
                <template slot="firstName" slot-scope="props">
                    <span>
                        {{props.cell_value}}
                    </span>
                </template>
                <template slot="lastName" slot-scope="props">
                    <span>
                        {{props.cell_value}}
                    </span>
                </template>
                <template slot="email" slot-scope="props">
                    <span>
                        {{props.cell_value}}
                    </span>
                </template>
                <template slot="state" slot-scope="props">
                    <span>
                        {{props.cell_value}}
                    </span>
                </template>
                <template slot="action" slot-scope="props">
                    <span>
                        <!-- {{props.row}} -->
                        <!-- <button @click="suspend(props.row)" class="btn_set">Suspend</button> -->
                        <button @click="suspend(props.row)" class="btn_set" v-if="props.row.suspendedStatus ==0">Suspend</button>
                        <button @click="suspend(props.row)" class="btn_act" v-if="props.row.suspendedStatus ==1">Suspended</button>
                    </span>
                    <span style="margin-left:2px">
                        <button @click="retire(props.row)" class="btn_act" v-if="props.row.accountStatus ==0">Retire</button>
                        <button @click="retire(props.row)" disabled class="btn_act2" v-if="props.row.accountStatus ==1">Retired</button>
                    </span>
                </template>
                <template slot="sort-asc-icon">
                    <i class="fas fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                    <i class="fas fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                    <i class="fas fa-sort"></i>
                </template>
            </vue-bootstrap4-table>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import Swal from 'sweetalert2'
///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";

/////////////////////////
import router from '@/router/index'
///////// IMPORT COOKIE SERVICE
import httpRequest from "@/services/httpRequests.js";
import Switches from 'vue-switches';

import VueBootstrap4Table from 'vue-bootstrap4-table'
let newRows;
export default {
    name: 'stateadminList',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            admin: null,
            state: null,
            columns: [{
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "First Name",
                    name: "firstName",
                    //   slot_name: "stateName",
                    sort: true,
                },
                {
                    label: "Last Name",
                    name: "lastName",
                    sort: true,
                },
                {
                    label: "Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Phone",
                    name: "phone",
                    sort: true,
                },
                {
                    label: "Created At",
                    name: "createdAt",
                    sort: true,
                },
                {
                    label: "State",
                    name: "enrolledState",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                }
            ],
            rows: [],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                selected_rows_info: true,
                card_title: "States Enrolled",
                global_search: {
                    placeholder: "Search Uploads",
                    visibility: true,
                    case_sensitive: false,
                },
                pagination: false, // default true
                pagination_info: false, // default true
                num_of_visibile_pagination_buttons: 7, // default 5
                per_page: 5, // default 10
                per_page_options: [5, 10, 20, 30],
            },
            // config: {
            //     show_refresh_button: false,
            //     show_reset_button: false,
            //     checkbox_rows: false,
            //     rows_selectable: true,
            //     selected_rows_info: true,
            //     card_title: "Institution Administrartors",
            //     global_search: {
            //         placeholder: "Search Admin",
            //         visibility: true,
            //         case_sensitive: false,
            //     },
            // },
        };
    },

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('admin/getinstitutionadmin').then(function (res) {
            next(vm => vm.setData(res))
        });
    },

    /// SCOPE METHODS
    methods: {
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },
        setData(data) {
            console.log(data);
            let adminData = data.data.data.rows;
            console.log(adminData);
            this.rows = adminData
            newRows = adminData;
        },
        suspend(admin) {
            this.admin = admin;
            // console.log(admin)
            // console.log('hello')
            // console.log({
            //     this: this
            // })
            let switchy = admin.suspendedStatus == '0' ? '1' : '0'
            let swdisplay = admin.suspendedStatus == '1' ? 'Admin Unsuspended' : 'Admin Suspended'
            const adminId = this.admin.adminId;
            let updateData = () => {
                this.rows.forEach(function (key, value) {
                    let vbcount = parseInt(value) + 1;
                    console.log(vbcount);
                    if (admin.vbt_id == vbcount) {
                        newRows[value].suspendedStatus = switchy
                    }
                })
                this.alertDisplay(swdisplay, 'Successfully', 'success');
            }
            // console.log(adminId);
            const fetch = httpRequest.put(`admin/institution/suspend/${adminId}`).then(function (res) {
                // console.log(res);
                if (res.data.code == 's200') {
                    updateData();
                    // this.rows.forEach(value => {
                    //     let vbcount = parseInt(value) + 1;
                    //     console.log(vbcount);
                    // });
                    //    newRows.forEach(function (key, value) {
                    //         console.log(`this is Admin Log ${admin}`);
                    //         let vbcount = parseInt(value) + 1;
                    //         console.log(vbcount);
                    //         if (admin.vbt_id == vbcount) {
                    //            newRows[value].suspendedStatus = switchy
                    //         }
                    //     })
                    // this.$swal(swdisplay, res.data.message, 'success');
                }
            })
        },

        retire(admin) {
            this.admin = admin
            let switchy = admin.accountStatus == '0' ? '1' : '0'
            let swdisplay = admin.accountStatus == '1' ? 'Admin Retired' : 'Admin Unretired'
            const data = {
                stateCode: this.admin.enrolledStateCode,
                adminId: this.admin.adminId
            };
            let updateAdmincode = () => {
                this.rows.forEach(function (key, value) {
                    let vbcount = parseInt(value) + 1;
                    console.log(vbcount);
                    if (admin.vbt_id == vbcount) {
                        newRows[value].accountStatus = switchy
                    }
                })
                this.alertDisplay(swdisplay, 'Successfully', 'success');

                // this.alertDisplay('Settings Saved', res.data.message, 'success');
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Status Changed Successfully',
                //     showConfirmButton: true,
                //     width: 500,
                // })
                // this.$swal(swdisplay, res.data.message, 'success');
            }
            // const statuscode = this.admin.accountStatus
            // console.log(this.admin.accountStatus)
            const fetch = httpRequest.post('admin/retire', data).then(function (res) {
                console.log({
                    res
                });
                if (res.data.code == 's200') {
                    updateAdmincode();
                    console.log('Jeg');
                    console.log(statuscode);
                    // console.log('jeg' + res)
                    // statuscode + 100;
                    // function increase (num) {
                    //     return statuscode + 100
                    // }
                    // increase(100)
                    Swal.fire({
                        icon: 'success',
                        title: 'Status Changed Successfully',
                        showConfirmButton: true,
                        width: 500,
                    })
                }
                // console.log(admin);
            })
        }

    }
}
</script>

<style scoped>
/* @import url(https://fonts.googleapis.com/css?family=Roboto:400, 500, 700);
@import url(https://fonts.googleapis.com/css?family=Karla:400, 700); */

template {
    position: relative;
    min-height: 100%;
}

.btn_act {
    padding: 10px;
    width: 89px;
    height: auto;
    border: none;
    margin: 0 10px;
    background: #FFF1F1;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #AE171D;
}

.btn_act2 {
    padding: 10px;
    width: 89px;
    height: auto;
    border: none;
    margin: 0 10px;
    background: #ccc6c7;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #fff;
}

.btn_set {
    width: 89px;
    height: 34px;
    background: #D9FFE1;
    border: none;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1D9C5F;
}

.admin_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

.card-header {
    font-weight: 600 !important;
    background-color: red;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.card_box {
    width: 100%;
    height: auto;
    margin: 40px 0;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 5% 20px;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}
</style>
